import { BaseEffect, EasingFunction, Easing, CanvasDimensions, EffectResult } from './BaseEffect';

export class OpacityEffect extends BaseEffect {
    from: number; // opacity value (0-1)
    to: number;   // opacity value (0-1)

    constructor(
        from: number, 
        to: number, 
        duration: number, 
        at?: number,
        easing: EasingFunction = Easing.easeInOutQuad
    ) {
        super('opacity', duration, at, easing);
        this.from = from;
        this.to = to;
    }

    apply(
        ctx: CanvasRenderingContext2D,
        dimensions: CanvasDimensions,
        progress: number,
        prev: EffectResult
    ): EffectResult {
        const currentOpacity = this.from + (this.to - this.from) * progress;
        ctx.globalAlpha = currentOpacity;
        return prev;
    }
} 